import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamQuestionSummary } from "@types";

export const useGetExamQuestionSummary = (examId?: string, enabled: boolean = true) => {
  const axios = useAxios();
  const { t } = useTranslation();

  const getExamQuestionSummary = async () => {
    try {
      const response = await axios.get<ExamQuestionSummary>(
        `/api/exam/${examId}/question-summary`
      );
      return response.data;
    } catch (error) {
      throw new Error(t("messages.error.getExamQuestionSummary"));
    }
  };

  return useQuery({
    queryKey: ["examQuestionSummary", examId],
    queryFn: getExamQuestionSummary,
    enabled: enabled && !!examId,
  });
};
